import React from "react";
import { Icon } from "@iconify/react";
import { useLanguage } from "../../hooks/use-language";
import { STEPS_STATES } from "../constants";

export const Stepper = (props) => {
	const lang = useLanguage();
	const { steps, onClickStep } = props;

	const currentActive = steps?.find((step) => step.currentState === STEPS_STATES.ACTIVE);

	const labels = {
		en: {
			step: "Step",
			current: "current",
			completed: "completed",
			disabled: "disabled",
			pending: "pending",
			navigation: "Progress steps of profile creation",
		},
		es: {
			step: "Paso",
			current: "actual",
			completed: "completado",
			disabled: "deshabilitado",
			pending: "pendiente",
			navigation: "Pasos del proceso de crear perfil",
		},
	};

	const t = labels[lang] || labels.es;

	return (
		<nav className="stepper w-100" aria-label={t.navigation}>
			<div className="line" style={{ height: 5 }} aria-hidden="true" />

			<ol className="d-flex w-100 justify-content-between align-items-center m-0 p-0">
				{steps.map((step, i) => {
					const isFinalStep = currentActive?.index === steps?.length;

					const isDisabled =
						isFinalStep ||
						step?.currentState === STEPS_STATES.DISABLED ||
						step?.currentState === STEPS_STATES.ACTIVE ||
						(currentActive?.backward !== true && step?.index < currentActive?.index);

					const isActive = step?.currentState === STEPS_STATES.ACTIVE;
					const isCompleted =
						step?.currentState === STEPS_STATES.COMPLETED || isFinalStep;

					let stateLabel = t.pending;

					if (isActive) stateLabel = t.current;
					else if (isCompleted) stateLabel = t.completed;
					else if (step?.currentState === STEPS_STATES.DISABLED) {
						stateLabel = t.disabled;
					}

					const ariaLabel = `${t.step} ${step.index} ${lang === "es" ? "de" : "of"} ${
						steps.length
					}, ${stateLabel}`;

					return (
						<li key={step.index ?? i} style={{ listStyle: "none", zIndex:1 }}>
							<button
								type="button"
								className={`step ${isCompleted ? STEPS_STATES.COMPLETED : step?.currentState}`}
								onClick={() => {
									if (!isDisabled) {
										onClickStep && onClickStep(step);
									}
								}}
								disabled={isDisabled}
								aria-label={ariaLabel}
								aria-current={isActive ? "step" : undefined}
								title={ariaLabel}
							>
								{isCompleted && (
									<>
										<Icon
											icon="ic:outline-check"
											width={24}
											aria-hidden="true"
										/>
									</>
								)}
							</button>
						</li>
					);
				})}
			</ol>
		</nav>
	);
};
